import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Card } from "@/components/app/StatusBadge";
import { api, formatApiError } from "@/lib/api";

const EMPTY = { name: "", role: "", rating: 5, quote_ms: "", quote_en: "" };

export const TestimonialsAdmin = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/testimonials").then((r) => setD(r.data)); }, []);
  if (!d) return null;
  const upd = (i, k, v) => setD({ ...d, items: d.items.map((t, j) => (j === i ? { ...t, [k]: v } : t)) });
  const save = async () => {
    try { await api.put("/admin/testimonials", d); toast.success("Testimoni disimpan — muat semula laman utama untuk melihat"); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="space-y-4" data-testid="admin-testimonials">
      <Card className="flex flex-wrap items-center justify-between gap-3 p-4">
        <label className="flex items-center gap-3 text-sm"><Switch checked={d.is_sample} onCheckedChange={(v) => setD({ ...d, is_sample: v })} data-testid="testimonials-sample-switch" /> Papar label "Contoh testimoni"</label>
        <div className="flex gap-2">
          <Button variant="outline" className="rounded-xl" onClick={() => setD({ ...d, items: [...d.items, { ...EMPTY }] })} data-testid="testimonial-add-btn"><Plus size={14} className="mr-1" /> Tambah</Button>
          <Button className="rounded-xl bg-violet-600 hover:bg-violet-700" onClick={save} data-testid="testimonials-save-btn">Simpan</Button>
        </div>
      </Card>
      <Card className="max-h-[640px] divide-y divide-slate-100 overflow-y-auto">
        {d.items.map((t, i) => (
          <div key={i} className="grid gap-2 p-4 sm:grid-cols-[1fr_1fr_80px_auto]" data-testid={`testimonial-row-${i}`}>
            <Input value={t.name} placeholder="Nama" onChange={(e) => upd(i, "name", e.target.value)} data-testid={`testimonial-name-${i}`} />
            <Input value={t.role} placeholder="Jawatan / sektor" onChange={(e) => upd(i, "role", e.target.value)} data-testid={`testimonial-role-${i}`} />
            <Input type="number" min={1} max={5} value={t.rating} onChange={(e) => upd(i, "rating", Math.min(5, Math.max(1, Number(e.target.value) || 5)))} data-testid={`testimonial-rating-${i}`} />
            <Button variant="ghost" className="text-red-600" onClick={() => setD({ ...d, items: d.items.filter((_, j) => j !== i) })} data-testid={`testimonial-delete-${i}`}><Trash2 size={15} /></Button>
            <div className="grid gap-2 sm:col-span-4 sm:grid-cols-2">
            <Textarea rows={3} value={t.quote_ms} placeholder="Petikan (BM)" onChange={(e) => upd(i, "quote_ms", e.target.value)} data-testid={`testimonial-ms-${i}`} />
            <Textarea rows={3} value={t.quote_en} placeholder="Quote (EN)" onChange={(e) => upd(i, "quote_en", e.target.value)} data-testid={`testimonial-en-${i}`} />
            </div>
          </div>
        ))}
      </Card>
    </div>
  );
};
